export default __webpack_public_path__ + "static/media/1.4d452e87.PNG";